import { UserPermission } from "config/constants"
import { useUnit } from "effector-react"
import { useMemo } from "react"
import { $maintenanceTypes, $isFetchingMaintenanceTypes, fetchMaintenanceTypes, $maintenanceTypesMap } from "stores/maintenanceTypes"
import { usePermissions } from "stores/permissions"

export default function useMaintenanceTypes() {
    const { hasPermission } = usePermissions()
    const maintenanceTypes = useUnit($maintenanceTypes)
    const isFetchingMaintenanceTypes = useUnit($isFetchingMaintenanceTypes)
    const maintenanceTypesMap = useUnit($maintenanceTypesMap)

    const maintenanceTypeSelectOptions = useMemo(() => {
        return maintenanceTypes?.map(ac => ({
            label: ac.name,
            value: ac.id,
        }))
    }, [maintenanceTypes])

    return {
        maintenanceTypes,
        maintenanceTypesMap,
        isFetchingMaintenanceTypes,
        fetchMaintenanceTypes: hasPermission(UserPermission.TenantSettingsMaintenanceView) ? fetchMaintenanceTypes : undefined,
        maintenanceTypeSelectOptions,
    }
}
